module.exports = __webpack_public_path__ + "static/media/Suitegalery3.15c33301.jpeg";